/*eslint no-template-curly-in-string: "off"*/
let waitHtml = require('./wait.html')
  .replace('${message}', gettext('Пожалуйста, подождите.'));

require('./frame-view.component.scss');

import {
  IS_IE_BROWSER
} from '../common/config.js';

function sanitizeUrl(maybeUrl) {

  let url = maybeUrl;
  let len = url.length;

  while (true) {
    url = decodeURIComponent(maybeUrl);
    if (url.length == len) break;
    len = url.length;
  }

  if (url.length > 1 && (url[0] !== '/' || url.indexOf('//') >= 0)) {
    return 'about:blank';
  }

  return url;
}

class FrameViewController {
  constructor(
    $cookies,
    $scope,
    $timeout,
    $element,
    $compile,
    rx,
    RouterService,
    FilterResource,
    FrameLoadService,
    ReportsSettingsModalService,
  ) {
    if ($cookies.get('theme') == 'dark') {
      waitHtml = waitHtml.replace('color:#000', 'color:fff')
      .replace('background-color:#333', 'background-color:#eee');
    }
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$element = $element;
    this.$compile = $compile;
    this.RouterService = RouterService;
    this.FilterResource = FilterResource;
    this.FrameLoadService = FrameLoadService;
    this.ReportsSettingsModalService = ReportsSettingsModalService;
    this.handleOnLoad = false;
    this.reload = false;
    // this.$scope.settingsRight = {
    //   right: '5px'
    // };

    this.setSettingsRight = () => {

      const iframeHtml = this.iframe[0].contentWindow && this.iframe.contents().find('html');
      if (iframeHtml && iframeHtml.length && iframeHtml[0].scrollHeight > iframeHtml[0].clientHeight) {
        this.$scope.settingsRight = {
          right: '18px',
        };
      } else {
        this.$scope.settingsRight = {
          marginTop: '-6px', 
          right: '5px'
        };
      }
    };

    $scope.showReportSettingsBtn = () => this.RouterService.CurrentFilterDataService.filter.mode === 'reports' &&
      !this.RouterService.frameUrl;

    this.$scope.openReportsSettings = () => this.ReportsSettingsModalService.open(this.src);
    this.$scope.$on('beforePrint', () => {
      this.beforePrint();
    });

    // $('sc-frame-view iframe').contents().on('click', e => jQuery( "body" ).trigger( jQuery.Event( "click" ) ))

    this.$scope.$on('afterPrint', () => {
      this.afterPrint();
    });
    const subscriptions = [
      $scope.$toObservable('$ctrl.cancelled')
      .subscribe(() => {
        if (this.cancelled && this.FrameLoadService.frames && this.FrameLoadService.frames.length) {
          for (const frame of this.FrameLoadService.frames) {
            frame.contentWindow.stop();
            console.log('Report cancelled');
          }
        }
      }),
      rx.Observable.merge(
        $scope.$toObservable('$ctrl.src'),
        $scope.$toObservable('$ctrl.maximize'),
        $scope.$eventToObservable('reload')
        .do(() => {
          this.reload = true;
        }),
      )
      .debounce(200)
      .subscribe(() => {
        this.updateSrc();
      }),
    ];

    $scope.$on('$destroy', () => {
      subscriptions.forEach((s) => s.dispose());
      if (this.iframe) {
        this.FrameLoadService.removeFrame(this.iframe[0]);
      }
    });
  }

  $onInit() {}

  $onDestroy() {}

  updateSrc() {
    if (this.iframe) {
      const src = this.iframe[0].contentWindow.document.location.pathname +
        this.iframe[0].contentWindow.document.location.search;
      if (this.src === src && !this.reload) {
        return;
      }
      this.iframe[0].removeEventListener('load', this.onload);
      this.FrameLoadService.removeFrame(this.iframe[0]);
      this.iframe.remove();
      this.iframe = null;
    }
    this.reload = false;
    if (!this.src || typeof this.maximize === 'undefined') {
      return;
    }
    if (this.maximize) {
      this.iframe = angular.element(
        '<iframe id= "iframe" frameborder="0" scrolling="no"></iframe>');
    } else {
      this.iframe = angular.element(
        '<iframe id= "iframe" frameborder="0" class="maximize"></iframe>');
    }
    if (this.maxheihgt) {
      this.iframe.height('100%');
    }
    this.$element.append(this.iframe);
    const frame = this.iframe[0];
    this.FrameLoadService.addFrame(frame);
    if (frame.contentWindow) frame.contentWindow.document.body.innerHTML = waitHtml;
    frame.RouterService = this.RouterService;

    this.$timeout(() => {
      this.setSettingsRight();
    }, 500);

    if (this.src.length > 1024 && !this.src.includes('/remote/'))
      this.FilterResource.sendHash(this.src)
      .then(src => {
        if (src)
          frame.src = src;
        else
          frame.src = sanitizeUrl(this.src);
      })
      .catch(err => {
        console.error(err);
        frame.src = sanitizeUrl(this.src);
      });
    else
      frame.src = sanitizeUrl(this.src);

    this.onload = () => {
      this.setSettingsRight();


      frame.contentWindow.addEventListener('mousedown', e => {
        if (e && (e.which == 2 || e.button == 4)) {
          e.preventDefault();
          e.stopPropagation();
        }
      });

      frame.contentWindow.addEventListener('mouseup', e => {
        if (e && (e.which == 2 || e.button == 4)) {
          e.preventDefault();
          e.stopPropagation();
          const oldUrl = window.location.href;
          let newUrl = oldUrl;
          $(e.target).click();
          this.$timeout(() => {
            newUrl = window.location.href;
            window.location.href = oldUrl;
            const win = window.open(newUrl);
          }, 100);
        }
      });

      //***************************************** // in order to close menu
      frame.contentWindow.document.addEventListener('click', e => {
        const newHeight = `${frame.contentWindow.document.firstElementChild.offsetHeight}px`;
        // if (newHeight !== frame.style.minHeight) frame.style.minHeight = newHeight;
        $('body sc-header').trigger($.Event('mousedown')).trigger($.Event('click')); // in order to close menu

      });

      if (this.onFrameLoad) {
        this.onFrameLoad({
          frame
        });
      }

      frame.setAttribute('sc-loaded', true);
      if (this.maximize) {
        frame.style['min-height'] = Math.max(
          this.minHeight || 0,
          frame.contentDocument.body.scrollHeight,
        ) + 'px';
        frame.style['min-width'] = frame.contentDocument.body.scrollWidth + 'px';
      }
      if (!frame.contentWindow) {
        return;
      }
      if (this.src.indexOf('remote/?play=') != -1)
        this.$scope.$emit('videoStarted');

      if (this.handleOnLoad) {
        const src = frame.contentWindow.document.location.pathname +
          frame.contentWindow.document.location.search;
        if (this.src !== src) {
          this.src = src;
          this.RouterService.openFrame(src);
          this.$scope.$root.$digest();
        }

        frame.contentWindow.document.addEventListener('click', (e) => {
          $('body sc-header').trigger($.Event('mousedown')).trigger($.Event('click')); // in order to close menu
          let node = e.target;

          while (node && node.localName !== 'a') {
            node = node.parentNode;
          }
          if (node && !node.classList.contains('noframe') && node.href &&
            (node.href.startsWith('/') || node.href.startsWith('http'))) {
            const src = node.pathname + node.search;
            this.RouterService.openFrame(src);
            e.preventDefault();
            this.$scope.$root.$digest();
            return false; // stop handling the click
          }
          return true;
        });
      }
    };

    this.iframe[0].addEventListener('load', this.onload, false);

    if (this.onFrameCreate) {
      this.onFrameCreate({
        frame
      });
    }
  }

  beforePrint() {
    if (!this.iframe) {
      return;
    }
    if (this.maximize) {
      this.iframe[0].style.height = this.iframe[0].contentDocument.body.scrollHeight + 'px';
      this.iframe[0].style.width = this.iframe[0].contentDocument.body.scrollWidth + 'px';
      this.iframe[0].setAttribute('scrolling', 'no');
    } else {
      this.iframe[0].style.height = (this.iframe.width() * 0.618) + 'px';
    }
  }

  afterPrint() {
    if (!this.iframe) {
      return;
    }
    this.iframe[0].style.removeProperty('height');
    this.iframe[0].style.removeProperty('width');
    if (this.maximize) {
      this.iframe[0].removeAttribute('scrolling');
    }
  }

  get showReportSettingsBtn() {
    return true;
  }
}

export const FrameViewComponent = {
  template: require('./frame-view.component.html'),
  bindings: {
    src: '<',
    maximize: '<',
    minHeight: '<?',
    cancelled: '<',
    onFrameCreate: '&?',
    onFrameLoad: '&?',
    handleOnLoad: '<?',
    maxheihgt: '<',
  },
  controller: FrameViewController,
};



// WEBPACK FOOTER //
// ./src/view/frame-view.component.js